

import React, { useState, useEffect } from 'react';
import { Cookies } from '../index.js';
import { Outlet, useNavigate } from "react-router-dom";
import { MdTextFields } from 'react-icons/md';
import { FaMicrophone, FaVideo, FaCloudUploadAlt, FaFileAlt } from 'react-icons/fa';
import axios from 'axios';
import { alert_error, alert_success } from '../AppContext';
import { RingLoader } from "react-spinners";
import Language_i18 from '../js/useNationalLanguage.jsx';
function Homehust() {
    const navigate = useNavigate();
    const [code_login, setcode_login] = useState('');
    const [keepFetching, setkeepFetching] = useState(true);
    const { lang } = Language_i18();
    const translations = {
        vi: {
            connectMode1: "Kết nối hoặc login Google chế độ 1",
            connectMode2: "Kết nối hoặc login Google chế độ 2",
            fallbackMode2: "Nếu chế độ 1 lỗi thì chọn cái này",
            loginSuccess: "Đăng nhập thành công",
            timeout: "Quá thời gian hãy thử lại",
            dataError: "Lỗi dữ liệu hãy load lại app"
        },
        en: {
            connectMode1: "Connect or login Google mode 1",
            connectMode2: "Connect or login Google mode 2",
            fallbackMode2: "If mode 1 fails, choose this",
            loginSuccess: "Login successful",
            timeout: "Timed out, please try again",
            dataError: "Data error, please reload the app"
        }
    };
    const t = translations[lang] || translations.vi;
    function switch_router(link) {
        navigate(link);
    };
    const [link1, setlink1] = useState('/shop/auth/login_google?device_type=android');
    const [link2, setlink2] = useState('/shop/auth/login_google?app=uiviewcontroller&device_type=android');
    const generateRandomString = (length) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let i = 0;
        // console.log(i);
        while (i < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            i++;
        }
        return result;
    };
    useEffect(() => {
        const randomString = generateRandomString(20);
        console.log('randomString ' + randomString);
        setcode_login(randomString);
        // Kiểm tra xem có giá trị "apikey" trong AsyncStorage không
        checkApiKey();
    }, []);
    const checkApiKey = () => {
        const apiKey = Cookies.get('apikey');
        if (apiKey) {
            // Có API key, thực hiện các hành động cần thiết
            console.log('Có API key:', apiKey);
            setlink1('/shop/auth/login_google?app=false&apikey=' + apiKey + '&chedo=update&device_type=android');
            setlink2('/shop/auth/login_google?app=uiviewcontroller&apikey=' + apiKey + '&chedo=update&device_type=android');
        } else {
            // Không có API key, thực hiện các hành động khác (ví dụ: yêu cầu người dùng nhập API key)
            console.log('Không có API key.');
        }

    };
    const login = (response, apikeyValue) => {
        // console.log(value);
        const device_id = Cookies.get('device_id');
        const device_type = Cookies.get('device_type');
        alert_success(t.loginSuccess);
        // Xử lý khi đăng nhập thành công
        console.log('Đăng nhập thành công');
        setTimeout(() => {
            if (device_type && device_id) {
                window.location.href = 'https://hust.media/api/auth/dang-nhap.php?apikey=' + apikeyValue + '&device_type=' + device_type + '&device_id=' + device_id;
            }
        }, 1500);
    };
    const login_google = async () => {
        const fetchData = async () => {
            console.log(code_login);
            let count = 0;
            while (keepFetching) {
                try {
                    count++;
                    if (count > 60) {
                        alert_error(t.timeout);
                        break;
                    }
                    else if (keepFetching) {
                        const url_check_login = "https://hust.media/api/auth/login_code_login.php?code_login=" + code_login;
                        console.log(url_check_login);
                        const response = await axios.get(url_check_login);
                        console.log(response.data);
                        if (!code_login) {
                            alert_error(t.dataError);
                            break;
                        }
                        if (count > 80) {
                            alert_error(t.timeout);
                            break;
                        }
                        else if (response.data.status == 1 || response.data.status == 2 || response.data.status == 3) {
                            console.log(response.data.message);
                            console.log(response.data.apikey);
                            if (response.data.status == 2) {
                                alert_error(response.data.message);
                            }
                            else if (response.data.status == 3) {
                                alert_error(response.data.message);
                                break;
                            }
                            else if (response.data.status == 1) {
                                const apikeyValue = response.data.apikey;
                                if (apikeyValue) {
                                    login(response, apikeyValue);
                                    break;
                                }
                            }
                        } else if (response.data.status == 0) {
                            console.log(response.data.message);
                        }
                        else {
                            console.log('Phản hồi không hợp lệ dừng vòng lặp');
                            break;
                        }
                    }
                    else {
                        console.log('Không tìm thấy code_login dừng vòng lặp');
                        break;
                    }
                } catch (error) {
                    console.error("Lỗi khi gửi yêu cầu:", error);
                    break;
                }
                await new Promise(resolve => setTimeout(resolve, 2700));
            }
        };
        fetchData();
        setTimeout(() => {
            window.open(link2 + `&code_login=` + code_login, '_blank');
        }, 300);
    };
    return (

        <div className="container-fluid ">

            <div className="row mt-4 mx-1">
                <div className="col-xl-4 mt-0">

                    <div className="card mb-4 bg-pink-500 shadow-lg rounded-xl">
                        <div className="grid gap-2">
                            <div className="bg-white border-2 rounded-lg shadow-md ">
                                <div onClick={() => window.location.href = link1} className="card">
                                    <button className="py-2 w-full flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white hover:from-pink-600 hover:to-purple-600 hover:text-white text-xl font-semibold shadow-lg focus:outline-none" type="button">
                                        <span className="mx-4">{t.connectMode1}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 mt-0">

                    <div className="card mb-4 bg-pink-500 shadow-lg rounded-xl">
                        <div className="grid gap-2">
                            <div className="bg-white border-2 rounded-lg shadow-md ">
                                <div onClick={() => login_google()} className="card">
                                    <button className="py-2  w-full flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white hover:from-pink-600 hover:to-purple-600 hover:text-white text-xl font-semibold shadow-lg focus:outline-none" type="button">
                                        <span className="mx-4">{t.connectMode2}</span>
                                    </button>
                                    <span className="text-center text-base">{t.fallbackMode2}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></div>
    )
}
export default Homehust
